import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstance } from "../../lib/axios";
import { INTEGRATION_SCOPES } from "../constants";

import { INTEGRATIONS_QUERY_KEY } from "./useFetchAllIntegrations";
import { CONNECTED_INTEGRATIONS_QUERY_KEY } from "./useFetchConnectedIntegration";

import type {
  DelinkIntegrationRequest,
  DelinkIntegrationResponse,
} from "../types/integrations";

// Hook to delink an integration
export const useDelinkIntegration = (options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      verifiableId,
      source,
      integrationScope = INTEGRATION_SCOPES.USER,
    }: DelinkIntegrationRequest) => {
      return await axiosInstance.post<DelinkIntegrationResponse>(
        "/connect/delink",
        { verifiableId, source, integration_scope: integrationScope },
      );
    },
    onSuccess: (response, variables) => {
      const integrationScope =
        variables.integrationScope ?? INTEGRATION_SCOPES.USER;

      // Invalidate related queries to refresh data
      queryClient.invalidateQueries({
        queryKey: CONNECTED_INTEGRATIONS_QUERY_KEY(
          variables.source,
          integrationScope,
        ),
      });
      queryClient.invalidateQueries({
        queryKey: INTEGRATIONS_QUERY_KEY(integrationScope),
      });

      // Call the success callback if provided
      options?.onSuccess?.();
    },
    onError: (error) => {
      console.error("Failed to delink integration:", error);
    },
  });
};
